exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createLeadContainer_from_CreateLeadModal-css_2DA {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"createLeadContainer": "createLeadContainer_from_CreateLeadModal-css_2DA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/createlead/CreateLeadModal.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadModal.css
// module chunks = 0